import { t } from 'i18next';
import * as yup from 'yup';

import { getEmptyErrorMessage, numberSchemaWithTransform } from 'core/yup';

export const addElementTemplateToJobSchema = () =>
  yup.object().shape({
    jobName: yup
      .string()
      .label(t('labelJobName'))
      .nullable()
      .required(getEmptyErrorMessage(t('labelJobName'))),
    name: yup
      .string()
      .label(t('labelElementName'))
      .nullable()
      .required(getEmptyErrorMessage(t('labelElementName'))),
    project: yup
      .object()
      .label(t('labelProject'))
      .nullable()
      .required(getEmptyErrorMessage(t('labelProject'))),
    quantity: numberSchemaWithTransform()
      .label(t('labelQuantity'))
      .required(getEmptyErrorMessage(t('labelQuantity')))
      .positive(),
  });
